

import { permissions } from "@/enum/applicationPermissions";
import { defineAbility } from "@casl/ability";

export default defineAbility((cannot) => {
  cannot(permissions.SEE_LOGS,'VIGIFLOW');
});